// extracted by mini-css-extract-plugin
export var numpadContainer = "_po-1";
export var phoneButton = "_po-0";